<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="warning" v-b-tooltip.hover :title="showToolTip ? 'Дублировать' : ''"><i class="fa fa-clone"></i></b-button>
</template>

<script>

export default ({
  name: "button-clone",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
